import app from '../slices/app'
import debug from '../slices/debug'
import dialogs from '../slices/dialogs'
import errors from '../slices/errors'
import flags from '../slices/flags'
import gallery from '../slices/gallery'
import infoBubble from '../slices/infoBubble'
import locale from '../slices/locale'
import map from '../slices/map'
import menus from '../slices/menus'
import settings from '../slices/settings'
import street from '../slices/street'
import system from '../slices/system'
import toasts from '../slices/toasts'
import ui from '../slices/ui'
import undo from '../slices/undo'
import user from '../slices/user'
import mainTool from '../../Multimodal/slices/mainTool'
import appSlice from '../../Multimodal/slices/appSlice'
import roadwayVariables from '../../Multimodal/slices/generalInputs/roadwayVariables'
import modalTiers from '../../Multimodal/slices/generalInputs/modalTiers'
import modalPrioritization from '../../Multimodal/slices/generalInputs/modalPrioritization'
import pedestrian from '../../Multimodal/slices/criteriaSelection/pedestrian'
import bicycle from '../../Multimodal/slices/criteriaSelection/bicycle'
import auto from '../../Multimodal/slices/criteriaSelection/auto'
import freight from '../../Multimodal/slices/criteriaSelection/freight'
import transit from '../../Multimodal/slices/criteriaSelection/transit'
import finalScores from '../../Multimodal/slices/finalScores'
import weakestLinkScores from '../../Multimodal/slices/weakestLinkScores'
import weakestLinkVariables from '../../Multimodal/slices/weakestLinkVariables'
import tourSlice from '../../Multimodal/slices/tourSlice'
import safetyMeasures from '../../Multimodal/slices/safetyMeasures'
import modalPrioritiesCardDict from '../../Multimodal/slices/generalInputs/modalPrioritiesCardDict'
import segmentSelectionToolbox from '../../Multimodal/slices/segmentSelectionToolbox'

const reducers = {
  app,
  debug,
  dialogs,
  errors,
  flags,
  gallery,
  infoBubble,
  locale,
  map,
  menus,
  settings,
  street,
  system,
  toasts,
  ui,
  undo,
  user,
  mainTool,
  appSlice,
  roadwayVariables,
  modalTiers,
  modalPrioritization,
  pedestrian,
  bicycle,
  auto,
  freight,
  transit,
  finalScores,
  weakestLinkScores,
  weakestLinkVariables,
  tourSlice,
  safetyMeasures,
  modalPrioritiesCardDict,
  segmentSelectionToolbox
}

export default reducers
